
const StepContent = ({children} : any) => {
    return (
      <div>{children}</div>
    );
}

export default StepContent;